
namespace TabAurous.Reports {
    import fld = TabAurous.Stock.StockItemRow.Fields;
    @Serenity.Decorators.registerClass()
    export class StoneStockGrid extends _Ext.GridBase<TabAurous.Stock.StockItemRow, any> {
        protected getColumnsKey() { return 'Stock.StoneStock'; } 
        protected getIdProperty() { return TabAurous.Stock.StockItemRow.idProperty; }
        protected getInsertPermission() { return TabAurous.Stock.StockItemRow.insertPermission; }
        protected getLocalTextPrefix() { return TabAurous.Stock.StockItemRow.localTextPrefix; }
        protected getService() { return TabAurous.Stock.StoneService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.addDateRangeFilter("VoucherDate", "Date");
            this.setTitle("");
        }
        protected getQuickFilters() {
            var filters = super.getQuickFilters();

            filters.push({
                type: Serenity.LookupEditor,
                options: {
                    lookupKey:'Stone',
                    multiple: true

                },
                field: 'ProductId',
                title: 'Product',
                handler: w => {
                    var temp = [];
                    var values = w.value;
                    for (var i = 0; i < values.length; i++) {
                        temp.push(parseInt(values[i]));
                    } if (temp.length != 0) {
                        (this.view.params as ReportFiltersRequest).ProductIds = temp;
                        //(this.view.params as ReportFiltersRequest).FinancialYearId = 0;
                        //(this.view.params as ReportFiltersRequest).FinancialYearId = 0;
                    } else if (temp.length == 0) {
                        (this.view.params as ReportFiltersRequest).ProductIds = temp;
                    }
                },

                cssClass: 'hidden-xs'
            });
            return filters;
        }
        protected getButtons(): Serenity.ToolButton[] {
            
            var buttons = super.getButtons();
            buttons.push({
                title: 'Print',
                icon: 'fa fa-print text-blue',
                //icon: 'fa-cloud-download',
                onClick: () => {

                    Common.ReportHelper.execute({
                        reportKey: 'Stock.StoneRegister',
                        params: {
                            CompanyIds: this.view.params.CompanyIds,
                            FinIds: this.view.params.FinancialYearIds,
                            VendorIds: this.view.params.VendorIds,
                            date: this.view.params.Criteria
                        }
                    });
                }
            }
            );
            return buttons;
        }
    }
}